"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "my-parfum-cookie-consent";

export default function CookieConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Daha önce bir tercih yapılmışsa banner bir daha gösterilmez
    const existing = localStorage.getItem(STORAGE_KEY);
    if (!existing) setVisible(true);
  }, []);

  const respond = (choice: "accepted" | "rejected") => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ choice, date: new Date().toISOString() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[100] p-4 md:p-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="max-w-4xl mx-auto bg-[#111114] border border-[rgba(201,168,76,0.2)] rounded-xl shadow-[0_10px_40px_rgba(0,0,0,0.6)] p-5 md:p-6 flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="w-10 h-10 rounded-full bg-[#C9A84C]/10 border border-[#C9A84C]/20 flex items-center justify-center text-[#C9A84C] shrink-0">
          <Cookie size={20} />
        </div>

        <div className="flex-1 space-y-1.5">
          <p className="text-sm text-[#F4F0E8] font-medium">Çerezleri Kullanıyoruz</p>
          <p className="text-xs text-[#7A7670] leading-relaxed">
            Sitemizin çalışması (oturum açma, sepetiniz, güvenlik) için gerekli çerezleri kullanıyoruz.
            Reklam veya analiz amaçlı üçüncü taraf çerez kullanmıyoruz. Detaylar için{" "}
            <Link href="/cerez-politikasi" className="text-[#C9A84C] hover:underline underline-offset-2">
              Çerez Politikamızı
            </Link>{" "}
            inceleyebilirsiniz.
          </p>
        </div>

        <div className="flex items-center gap-3 shrink-0 w-full md:w-auto">
          <button
            type="button"
            onClick={() => respond("rejected")}
            className="flex-1 md:flex-none border border-[rgba(201,168,76,0.2)] text-[#7A7670] px-5 py-2.5 rounded text-[11px] font-bold uppercase tracking-widest hover:border-[rgba(201,168,76,0.4)] hover:text-[#F4F0E8] transition"
          >
            Reddet
          </button>
          <button
            type="button"
            onClick={() => respond("accepted")}
            className="flex-1 md:flex-none bg-[#C9A84C] text-black px-5 py-2.5 rounded text-[11px] font-bold uppercase tracking-widest hover:bg-[#D4B664] transition"
          >
            Kabul Et
          </button>
          <button
            type="button"
            onClick={() => respond("accepted")}
            aria-label="Kapat"
            title="Kapat (kabul edilmiş sayılır)"
            className="hidden md:flex p-2 text-[#7A7670]/50 hover:text-[#C9A84C] transition"
          >
            <X size={16} />
          </button>
        </div>
      </div>
    </div>
  );
}
